/**
 * @generated SignedSource<<13543461fb99ac78ba771553a1ab1abb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PerformanceOverviewChart_chart$data = {
  readonly datepicker: {
    readonly " $fragmentSpreads": FragmentRefs<"Datepicker_text">;
  } | null | undefined;
  readonly datepickerbuttontexts: string | null | undefined;
  readonly " $fragmentType": "PerformanceOverviewChart_chart";
};
export type PerformanceOverviewChart_chart$key = {
  readonly " $data"?: PerformanceOverviewChart_chart$data;
  readonly " $fragmentSpreads": FragmentRefs<"PerformanceOverviewChart_chart">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PerformanceOverviewChart_chart",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PerformanceOverviewDatepicker",
      "kind": "LinkedField",
      "name": "datepicker",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Datepicker_text"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "datepickerbuttontexts",
      "storageKey": null
    }
  ],
  "type": "PerformanceOverviewChart",
  "abstractKey": null
};

(node as any).hash = "59de3e6c5e9342d3c68e6ee6c67ff542";

export default node;
